export default __webpack_public_path__ + "static/media/gallery-wip-emitter-cover_01.83424ec4.jpg";